export default __webpack_public_path__ + "./images/ar.ef0bad00.png";